import {CONFIG_AUTHORIZATION_CONNECT_PARTNER} from "../constant";

const roles = {
  ADMIN: 'ROLE_ADMIN',
  MANAGER: 'ROLE_MANAGER',
  USER: 'ROLE_USER'
};

export default {
  roles: roles,
  authenSuccesUrlRedirect: function (hasAuthor) {
    // if (hasAuthor(roles.CREATE)) {
    //   return '/user-management/managed-users';
    // } else if (hasAuthor(roles.CREATE)) {
    //   return '/user-management/managed-users';
    // } else {
    //   return '/user-management/managed-users';
    // }
    return '/dashboard.html'
  },

  authorizationMapper: [
    {
      regex: /^\/dashboard.html/,
      isAuthorized: function (hasAuthor) {
        return hasAuthor(roles.ADMIN) || hasAuthor(roles.MANAGER) || hasAuthor(roles.USER);
      }
    },
    {
      regex: /^\/devices-management*/,
      isAuthorized: function (hasAuthor) {
        return hasAuthor(roles.ADMIN) || hasAuthor(roles.MANAGER) || hasAuthor(roles.USER);
      }
    },
    {
      regex: /^\/files-screen-management*/,
      isAuthorized: function (hasAuthor) {
        return hasAuthor(roles.ADMIN) || hasAuthor(roles.MANAGER) || hasAuthor(roles.USER);
      }
    },
    {
      regex: /^\/schedule-management*/,
      isAuthorized: function (hasAuthor) {
        return hasAuthor(roles.ADMIN) || hasAuthor(roles.MANAGER) || hasAuthor(roles.USER);
      }
    },
    {
      regex: /^\/history-management*/,
      isAuthorized: function (hasAuthor) {
        return hasAuthor(roles.ADMIN) || hasAuthor(roles.MANAGER) || hasAuthor(roles.USER);
      }
    },
    {
      regex: /^\/administrator\/user-activity-log.html/,
      isAuthorized: function (hasAuthor) {
        return hasAuthor(roles.ADMIN) || hasAuthor(roles.MANAGER) || hasAuthor(roles.USER);
      }
    },
    {
      regex: /^\/administrator\/file-type.html/,
      isAuthorized: function (hasAuthor) {
        return hasAuthor(roles.ADMIN) || hasAuthor(roles.PROVINCE);
      }
    },
    {
      regex: /^\/administrator\/key-authentication.html/,
      isAuthorized: function (hasAuthor) {
        return hasAuthor(roles.ADMIN);
      }
    },
    {
      regex: /^\/administrator\/cache.html/,
      isAuthorized: function (hasAuthor) {
        return hasAuthor(roles.ADMIN);
      }
    },
    {
      regex: /^\/administrator\/channel-digital.html/,
      isAuthorized: function (hasAuthor) {
        return hasAuthor(roles.ADMIN) || hasAuthor(roles.MANAGER);
      }
    },
    {
      regex: /^\/user-management\/managed-users.html/,
      isAuthorized: function (hasAuthor) {
        return hasAuthor(roles.ADMIN) && !CONFIG_AUTHORIZATION_CONNECT_PARTNER;
      }
    },
    {
      regex: /^\/administrator\/sim.html/,
      isAuthorized: function (hasAuthor) {
        return hasAuthor(roles.ADMIN);
      }
    },
    {
      regex: /^\/administrator\/thread.html/,
      isAuthorized: function (hasAuthor) {
        return hasAuthor(roles.ADMIN);
      }
    },
    {
      regex: /^\/administrator\/sound-speaker.html/,
      isAuthorized: function (hasAuthor) {
        return hasAuthor(roles.ADMIN);
      }
    },
    {
      regex: /^\/administrator\/config-authentication.html/,
      isAuthorized: function (hasAuthor) {
        return hasAuthor(roles.ADMIN);
      }
    }
  ]
}
